import {TS_HISTORY, TS_LEADERBOARD, TS_REGISTER, TS_EVENT} from '../actions/top_spender/type';

const initState = {leaderboards: [], registerResult: null, registerError: null, historyRecords: [], historyCount: 0, eventResult: null, eventData: null}
export default function(state = initState, action) {
    switch(action.type) {
        case TS_REGISTER: 
            return {...state, registerResult: action.payload, registerError: action.message}
        case TS_LEADERBOARD:
            return {...state, leaderboards: action.payload}
        case TS_HISTORY:
            const historyRecords = action.payload.data
            const historyCount = action.payload.count
            return {...state, historyRecords: historyRecords, historyCount: historyCount}
        case TS_EVENT:
            const result = action.payload
            const event_data = action.data
            return {...state, eventResult: result, eventData: event_data}

        default: 
            return state;
    }
}